export default __webpack_public_path__ + "static/media/design.82d7bdc8.svg";